import React from "react";
import Slider from "react-slick";
import NextArrow from "~/components/slickSlider/NextArrow";
import PrevArrow from "~/components/slickSlider/PrevArrow";
import { Link } from "react-router-dom";
import "./ListCategories.scss";

function ListCategories({ listCategory }) {
  // Slick Slider
  var CategorySlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(Math.max(listCategory?.length, 1), 4),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(Math.max(listCategory?.length, 1), 3),
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(Math.max(listCategory?.length, 1), 2),
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(Math.max(listCategory?.length, 1), 2),
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="my-5">
      <div className="sub-title-heading">Danh mục</div>
      <h3 className="title-heading">
        <Link to="/category">Danh mục sản phẩm</Link>
      </h3>
      <Slider className="slider-category" {...CategorySlider}>
        {listCategory?.length === 0 ? (
          <div>Chưa có danh mục sản phẩm</div>
        ) : (
          listCategory?.map((item) => {
            return (
              <Link
                to={`/category/${item.cateSlug}`}
                key={item._id}
                className="link-to-category"
              >
                <div className="items d-flex justify-content-center align-items-center flex-column p-3">
                  <div className="img-content">
                    <img src={item.image} alt={item.description} />
                  </div>
                  <div className="title">{item.cateName}</div>
                </div>
              </Link>
            );
          })
        )}
      </Slider>
    </div>
  );
}

export default ListCategories;
